
enum CustomCategoryType{
    GROUP = "GROUP",
    INDIVIDUAL = "INDIVIDUAL",
}
export default CustomCategoryType